import {ENROLL_ADD_SECTION, ENROLL_REMOVE_SECTION, SELECT_ENROLL_SUBJECT} from '../actionTypes'


export default function (state = {subject: {}}, action) {
    //console.log(action.type);
    //console.log(action.payload);
    switch (action.type) {
        case SELECT_ENROLL_SUBJECT:
            return action.payload
        case ENROLL_ADD_SECTION:
            if (state.sections) {
                let sections = state.sections.filter(sec => {
                    return sec.sectionId != action.payload.sectionId
                })
                sections.push(action.payload)
                state.sections = sections
            } else {
                state.sections = [action.payload]
            }
            return state
        case ENROLL_REMOVE_SECTION:
            if (state.sections) {
                let sections = state.sections.filter(sec => {
                    return sec.sectionId != action.payload.sectionId
                })
                state.sections = sections
            }
            return state

    }

    return state;
}